(() => {
  const root = document.querySelector('[data-cs-global-week-root]');
  if (!root || root.dataset.csGlobalWeekReady === 'true') return;
  root.dataset.csGlobalWeekReady = 'true';

  const WEEKDAYS = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
  };

  const FALLBACKS = {
    'parmer-ranch-porch-pickup': {
      icon: 'house',
      color: '#7EA8A6',
      coordinates: { lat: 30.735764, lng: -97.786975 }
    },
    'parmer-ranch-park': {
      icon: 'tree',
      color: '#6F8F6A',
      coordinates: { lat: 30.738026459677197, lng: -97.793715597013 }
    },
    'arboretum-farmers-market': {
      icon: 'tent',
      color: '#2B3647',
      coordinates: { lat: 30.406169, lng: -97.75743 }
    },
    'bee-cave-farmers-market': {
      icon: 'bee',
      color: '#BE9140',
      coordinates: { lat: 30.3088, lng: -97.9405 }
    }
  };

  const ICONS = {
    house: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M3 11.2 12 4l9 7.2"/>
        <path d="M5.5 10.5V20h13v-9.5"/>
        <path d="M9.5 20v-5.5h5V20"/>
      </svg>`,
    tree: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 21v-6"/>
        <path d="M8.5 21h7"/>
        <path d="M12 3 7.5 10h2.7L6.5 15h11l-3.7-5h2.7L12 3Z"/>
      </svg>`,
    tent: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M3 9h18"/>
        <path d="m5 9 2-5h10l2 5"/>
        <path d="M5 9v11h14V9"/>
        <path d="M9 20v-7h6v7"/>
        <path d="M8 4v5M12 4v5M16 4v5"/>
      </svg>`,
    bee: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M7.4 12.6c0-2.6 2-4.6 4.6-4.6s4.6 2 4.6 4.6-2 4.6-4.6 4.6-4.6-2-4.6-4.6Z"/>
        <path d="M9.2 9.1c-.8-2.1-2.6-3.2-4.2-2.3-1.5.9-.9 3.3 2.4 4.5M14.8 9.1c.8-2.1 2.6-3.2 4.2-2.3 1.5.9.9 3.3-2.4 4.5"/>
        <path d="M9.4 9.1v7M12 8.1v9M14.6 9.1v7"/>
        <path d="M7.4 12.6H4.5M16.6 12.6h2.9"/>
      </svg>`,
    triangle: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 4 21 20H3L12 4Z"/>
      </svg>`,
    pin: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"/>
        <circle cx="12" cy="10" r="2.5"/>
      </svg>`
  };

  const RAIN_TYPES = new Set([
    'DRIZZLE',
    'LIGHT_RAIN',
    'MODERATE_RAIN',
    'HEAVY_RAIN',
    'RAIN_SHOWERS',
    'SCATTERED_SHOWERS',
    'SHOWERS',
    'THUNDERSTORM',
    'SCATTERED_THUNDERSTORMS',
    'HEAVY_THUNDERSTORMS'
  ]);

  const WEATHER_EMOJI = {
    CLEAR: '☀️',
    MOSTLY_CLEAR: '🌤️',
    PARTLY_CLOUDY: '🌤️',
    MOSTLY_CLOUDY: '⛅',
    CLOUDY: '☁️',
    FOG: '🌫️',
    LIGHT_RAIN: '🌦️',
    DRIZZLE: '🌦️',
    SCATTERED_SHOWERS: '🌦️',
    RAIN_SHOWERS: '🌧️',
    SHOWERS: '🌧️',
    MODERATE_RAIN: '🌧️',
    HEAVY_RAIN: '🌧️',
    THUNDERSTORM: '⛈️',
    SCATTERED_THUNDERSTORMS: '⛈️'
  };

  const LOCATION_NOTES = {
    'arboretum-farmers-market':
      'Quick parking makes Arboretum an easy rainy-day stop.',
    'parmer-ranch-park':
      'Coffee, fresh bread, and neighborhood support—rain or shine.',
    'bee-cave-farmers-market':
      'Bring an umbrella and show the Galleria vendors some rainy-day love.',
    'parmer-ranch-porch-pickup':
      'Rain or shine, your order will be waiting on the covered porch.'
  };

  const escapeHTML = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  const normalize = (value) => String(value || '').trim().toLowerCase();

  const LOCAL_SHOP_URL = '/pages/about-us?view=shop&mode=local';

  const buildLocationOrderUrl = (location) => {
    if (!location?.handle) return LOCAL_SHOP_URL;

    if (location.handle === 'parmer-ranch-porch-pickup') {
      return '/pages/parmer-ranch-porch-pickup';
    }

    const url = new URL(LOCAL_SHOP_URL, window.location.origin);
    const pickupSubtype = normalize(location.subtype || '');

    url.searchParams.set('view', 'shop');
    url.searchParams.set('mode', 'local');
    url.searchParams.set('gateway', 'skip');
    url.searchParams.set(
      'shopping_path',
      pickupSubtype === 'bakehouse_order_ahead' ||
        location.handle === 'cold-sugar-bakehouse-parmer-ranch'
        ? 'bakehouse_order_ahead'
        : 'market_pickup'
    );
    url.searchParams.set('fulfillment', location.handle);

    return `${url.pathname}${url.search}${url.hash}`;
  };

  const dataElement = root.querySelector('[data-cs-global-week-data]');
  let locations = [];

  try {
    const parsed = JSON.parse(dataElement?.textContent || '[]');
    locations = Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error('Cold Sugar global This Week data could not be parsed.', error);
  }

  const trigger = root.querySelector('[data-cs-week-trigger]');
  const overlay = root.querySelector('[data-cs-week-overlay]');
  const drawer = root.querySelector('[data-cs-week-drawer]');
  const closeButton = root.querySelector('[data-cs-week-close]');
  const drawerEvents = root.querySelector('[data-cs-drawer-events]');
  const drawerRain = root.querySelector('[data-cs-drawer-rain]');
  const weatherEndpoint = root.dataset.weatherEndpoint || '';
  let lastFocusedElement = null;
  // Avoid loading market forecasts on every website page navigation.
  // Fetch only when someone opens the Coming Up drawer.
  let weatherLoadStarted = false;

  const parseBlockedDates = (value) =>
    String(value || '').match(/\d{4}-\d{2}-\d{2}/g) || [];

  const parseTimeToMinutes = (value) => {
    const match = String(value || '')
      .trim()
      .toUpperCase()
      .match(/(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/);

    if (!match) return null;

    let hour = Number(match[1]);
    const minute = Number(match[2] || 0);

    if (match[3] === 'PM' && hour !== 12) hour += 12;
    if (match[3] === 'AM' && hour === 12) hour = 0;

    return hour * 60 + minute;
  };

  const getEventHours = (location) => {
    const value = String(location.timeWindow || location.displaySchedule || '');
    const parts = value.split(/[–—-]/);
    if (parts.length < 2) return { startHour: 10, endHour: 14 };

    const startMinutes = parseTimeToMinutes(parts[0]);
    const endMinutes = parseTimeToMinutes(parts[parts.length - 1]);

    if (startMinutes === null || endMinutes === null || endMinutes <= startMinutes) {
      return { startHour: 10, endHour: 14 };
    }

    return {
      startHour: Math.floor(startMinutes / 60),
      endHour: Math.ceil(endMinutes / 60)
    };
  };

  const getTexasNow = () => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(new Date());

    const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));

    return {
      date: new Date(
        Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day))
      ),
      hour: Number(values.hour),
      minute: Number(values.minute)
    };
  };

  const isoDate = (date) =>
    `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(
      2,
      '0'
    )}-${String(date.getUTCDate()).padStart(2, '0')}`;

  const getNextOccurrence = (location) => {
    const targetDays = String(location.activeWeekdays || '')
      .toLowerCase()
      .split(/[,\n|]+/)
      .map((item) => WEEKDAYS[item.trim()])
      .filter(Number.isInteger);

    if (!targetDays.length) return null;

    const texas = getTexasNow();
    const currentDay = texas.date.getUTCDay();
    const currentMinutes = texas.hour * 60 + texas.minute;
    const eventWindow =
      location.timeWindow || location.displaySchedule || '';
    const timeParts = String(eventWindow).split(/[–—-]/);
    const endMinutes =
      parseTimeToMinutes(timeParts[timeParts.length - 1]) ?? 14 * 60;

    const candidates = targetDays.map((targetDay) => {
      let offset = (targetDay - currentDay + 7) % 7;
      if (offset === 0 && endMinutes !== null && currentMinutes >= endMinutes) {
        offset = 7;
      }

      const date = new Date(texas.date);
      date.setUTCDate(date.getUTCDate() + offset);
      return date;
    });

    const date = candidates.sort((a, b) => a - b)[0];

    if (location.startDate) {
      const start = new Date(`${location.startDate}T00:00:00Z`);
      while (date < start) date.setUTCDate(date.getUTCDate() + 7);
    }

    if (location.endDate) {
      const end = new Date(`${location.endDate}T23:59:59Z`);
      if (date > end) return null;
    }

    const startMinutes = parseTimeToMinutes(timeParts[0]) ?? 0;
    const minutesUntilStart =
      ((date - texas.date) / 86400000) * 1440 +
      startMinutes -
      currentMinutes;

    if (minutesUntilStart > 7 * 24 * 60) return null;

    const iso = isoDate(date);
    return {
      date,
      iso,
      blocked: parseBlockedDates(location.blockedDates).includes(iso)
    };
  };

  const formatDate = (date) =>
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    }).format(date);

  const safeColor = (value, fallback) =>
    /^#[0-9a-f]{6}$/i.test(String(value || '').trim())
      ? String(value).trim()
      : fallback;

  const getIdentity = (location) => {
    const fallback = FALLBACKS[location.handle] || {};
    const requestedIcon = normalize(location.icon || fallback.icon || 'pin');

    return {
      icon: ICONS[requestedIcon] ? requestedIcon : 'pin',
      color: safeColor(location.color, fallback.color || '#2B3647')
    };
  };

  const getCoordinates = (location) => {
    const latitude = location.latitude == null || location.latitude === '' ? NaN : Number(location.latitude);
    const longitude = location.longitude == null || location.longitude === '' ? NaN : Number(location.longitude);

    if (
      Number.isFinite(latitude) &&
      Number.isFinite(longitude) &&
      Math.abs(latitude) <= 90 &&
      Math.abs(longitude) <= 180 &&
      latitude !== 0 &&
      longitude !== 0
    ) {
      return { lat: latitude, lng: longitude };
    }

    return FALLBACKS[location.handle]?.coordinates || null;
  };

  // Only actual market/event stops belong in the global schedule drawer.
  const upcoming = locations
    .filter((location) => {
      const subtype = normalize(location.subtype);
      return subtype !== 'bakehouse_order_ahead' && subtype !== 'porch_pickup';
    })
    .map((location) => ({
      ...location,
      occurrence: getNextOccurrence(location)
    }))
    .filter((location) => location.occurrence)
    .sort((a, b) => {
      const dateDifference = a.occurrence.date - b.occurrence.date;
      return dateDifference || Number(a.sortOrder || 999) - Number(b.sortOrder || 999);
    });

  const renderEventCard = (location) => {
    const identity = getIdentity(location);
    const blocked = location.occurrence.blocked;

    const orderUrl = blocked
      ? ''
      : buildLocationOrderUrl(location);

    const cardTag = blocked ? 'article' : 'a';

    const cardAttributes = blocked
      ? ''
      : `href="${escapeHTML(orderUrl)}" aria-label="Shop ${escapeHTML(
          location.name
        )}"`;

    const actionLabel =
      location.handle === 'parmer-ranch-porch-pickup'
        ? 'View Porch Shop'
        : 'Shop this stop';

    return `
      <${cardTag}
        class="cs-week-drawer__event${blocked ? ' is-cancelled' : ''}"
        data-drawer-handle="${escapeHTML(location.handle)}"
        style="--cs-location-color:${escapeHTML(identity.color)}"
        ${cardAttributes}
      >
        <span class="cs-global-week__event-icon" aria-hidden="true">
          ${ICONS[identity.icon]}
        </span>

        <small>${escapeHTML(formatDate(location.occurrence.date))} · ${escapeHTML(
          location.timeWindow || location.displaySchedule || ''
        )}</small>

        ${blocked ? '<span class="cs-week-drawer__cancel-badge" role="status">Cancelled</span>' : ''}
        <h3>${escapeHTML(location.name)}</h3>
        <p>${escapeHTML(location.cityState || '')}</p>
        ${blocked ? `<p class="cs-week-drawer__cancel-message">Cold Sugar will not be at this stop on ${escapeHTML(formatDate(location.occurrence.date))}. Please choose another stop.</p>` : ''}

        ${
          blocked
            ? ''
            : `<div class="cs-week-drawer__weather" data-drawer-weather="${escapeHTML(
                location.handle
              )}"></div>
              <p class="cs-week-drawer__rain-note" data-drawer-rain-note="${escapeHTML(
                location.handle
              )}"></p>`
        }

        ${
          blocked
            ? ''
            : `<span class="cs-week-drawer__event-action">${escapeHTML(
                actionLabel
              )} <span aria-hidden="true">→</span></span>`
        }
      </${cardTag}>
    `;
  };

  const renderEventGroup = (label, items) => `
    <section class="cs-week-drawer__group">
      <p class="cs-week-drawer__group-label">${escapeHTML(label)}</p>
      <div class="cs-week-drawer__group-events">
        ${items.map(renderEventCard).join('')}
      </div>
    </section>
  `;

  const renderEvents = () => {
    if (!drawerEvents) return;

    if (!upcoming.length) {
      drawerEvents.innerHTML =
        '<p class="cs-week-drawer__empty">No upcoming locations are currently listed. View the full schedule for updates.</p>';
      return;
    }

    const attending = upcoming.filter(
      (location) => !location.occurrence.blocked
    );

    const notAttending = upcoming.filter(
      (location) => location.occurrence.blocked
    );

    const sections = [];

    if (!attending.length && notAttending.length) {
      sections.push(`
        <div class="cs-week-drawer__week-status cs-week-drawer__week-status--closed">
          <strong>No upcoming Cold Sugar stops</strong>
          <span>There are no scheduled Cold Sugar stops in the next 7 days. Check the full schedule for updates.</span>
        </div>
      `);
    }

    if (attending.length) {
      sections.push(
        notAttending.length
          ? renderEventGroup('Upcoming stops', attending)
          : attending.map(renderEventCard).join('')
      );
    }

    if (notAttending.length) {
      sections.push(
        renderEventGroup('Cancellations', notAttending)
      );
    }

    drawerEvents.innerHTML = sections.join('');
  };

  const openDrawer = () => {
    if (!overlay || !drawer || !trigger) return;

    lastFocusedElement = document.activeElement;
    overlay.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('cs-week-drawer-open');

    window.requestAnimationFrame(() => {
      overlay.classList.add('is-open');
      closeButton?.focus({ preventScroll: true });
    });

    if (!weatherLoadStarted) {
      weatherLoadStarted = true;
      void loadWeather();
    }
  };

  const closeDrawer = () => {
    if (!overlay || !drawer || !trigger) return;

    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('cs-week-drawer-open');

    window.setTimeout(() => {
      overlay.hidden = true;
    }, 260);

    if (lastFocusedElement instanceof HTMLElement) {
      lastFocusedElement.focus({ preventScroll: true });
    }
  };

  trigger?.addEventListener('click', openDrawer);
  closeButton?.addEventListener('click', closeDrawer);

  overlay?.addEventListener('click', (event) => {
    if (event.target === overlay) closeDrawer();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && overlay && !overlay.hidden) {
      event.preventDefault();
      closeDrawer();
    }
  });

  const toFahrenheit = (temperature) => {
    if (!temperature || typeof temperature.degrees !== 'number') return null;
    if (temperature.unit === 'FAHRENHEIT') return Math.round(temperature.degrees);
    return Math.round((temperature.degrees * 9) / 5 + 32);
  };

  const forecastType = (forecast) =>
    forecast?.weatherCondition?.type || forecast?.daytimeForecast?.weatherCondition?.type || '';

  const forecastDescription = (forecast) =>
    forecast?.weatherCondition?.description?.text ||
    forecast?.daytimeForecast?.weatherCondition?.description?.text || 'Forecast available';

  const forecastTemperatureLabel = (forecast) => {
    const low = toFahrenheit(forecast?.minTemperature);
    const high = toFahrenheit(forecast?.maxTemperature);
    if (low === null && high === null) {
      const dailyHigh = toFahrenheit(forecast?.maxTemperature || forecast?.daytimeForecast?.maxTemperature);
      return dailyHigh !== null ? `${dailyHigh}°` : '';
    }

    if (low !== null && high !== null) {
      return low === high ? `${low}°` : `${low}–${high}°`;
    }

    if (high !== null) return `${high}°`;
    if (low !== null) return `${low}°`;
    return '';
  };

  const forecastProbability = (forecast) => {
    const raw = forecast?.precipitationProbabilityPercent ??
      forecast?.daytimeForecast?.precipitation?.probability?.percent;
    const probability = Number(raw);
    return raw !== undefined && raw !== null && Number.isFinite(probability) ? probability : 0;
  };

  const isRainy = (forecast) => {
    if (typeof forecast?.rainy === 'boolean') return forecast.rainy;

    const probability = forecastProbability(forecast);
    const type = forecastType(forecast);

    return probability >= 40 || (RAIN_TYPES.has(type) && probability >= 20);
  };

  const fetchForecast = async (location) => {
    if (!weatherEndpoint || location.occurrence.blocked) return null;

    const coordinates = getCoordinates(location);
    if (!coordinates) return null;

    const eventHours = getEventHours(location);
    const cacheKey = `csGlobalWeatherV2:${location.handle}:${location.occurrence.iso}:${eventHours.startHour}-${eventHours.endHour}`;

    // Both schedule cards and the drawer can reuse the same browser forecast.
    const cacheKeys = [
      cacheKey,
      `csWeatherV2:${location.handle}:${location.occurrence.iso}:${eventHours.startHour}-${eventHours.endHour}`
    ];
    for (const key of cacheKeys) {
      try {
        const cached = JSON.parse(window.localStorage.getItem(key) || 'null');
        if (cached?.forecast && cached.savedAt && Date.now() - cached.savedAt < 30 * 60 * 1000) {
          return cached.forecast;
        }
      } catch (_error) {
        // Continue without browser cache.
      }
    }

    const endpoint = new URL(weatherEndpoint, window.location.origin);
    endpoint.searchParams.set('lat', String(coordinates.lat));
    endpoint.searchParams.set('lng', String(coordinates.lng));
    endpoint.searchParams.set('date', location.occurrence.iso);
    endpoint.searchParams.set('handle', location.handle);
    endpoint.searchParams.set('startHour', String(eventHours.startHour));
    endpoint.searchParams.set('endHour', String(eventHours.endHour));

    const response = await fetch(endpoint.toString(), {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) return null;

    const payload = await response.json();
    const candidate = payload.forecast || payload.eventForecast || payload.dailyForecast || payload;
    const forecast = candidate && (
      candidate.weatherCondition || candidate.daytimeForecast ||
      candidate.maxTemperature || candidate.minTemperature
    ) ? candidate : null;
    if (!forecast) return null;

    try {
      window.localStorage.setItem(
        cacheKey,
        JSON.stringify({ savedAt: Date.now(), forecast })
      );
    } catch (_error) {
      // Ignore storage failures.
    }

    return forecast;
  };

  const loadWeather = async () => {
    if (!weatherEndpoint || !upcoming.length) return;

    const results = await Promise.all(
      upcoming.map(async (location) => ({
        location,
        forecast: await fetchForecast(location).catch(() => null)
      }))
    );

    let rainyMarket = false;

    results.forEach(({ location, forecast }) => {
      if (!forecast) {
        root.querySelectorAll(`[data-drawer-weather="${CSS.escape(location.handle)}"]`)
          .forEach((element) => {
            element.textContent = 'Forecast unavailable';
            element.classList.add('is-ready', 'is-unavailable');
          });
        return;
      }

      const rainy = isRainy(forecast);
      const subtype = normalize(location.subtype);

      if (
        rainy &&
        ['farmers_market', 'neighborhood_park'].includes(subtype)
      ) {
        rainyMarket = true;
      }

      const type = forecastType(forecast);
      const temperature = forecastTemperatureLabel(forecast);
      const description = forecastDescription(forecast);
      const snippet = `${WEATHER_EMOJI[type] || '🌤️'} ${
        temperature ? `${temperature} · ` : ''
      }${description}`;

      root
        .querySelectorAll(
          `[data-drawer-weather="${CSS.escape(location.handle)}"]`
        )
        .forEach((element) => {
          element.textContent = snippet;
          element.classList.add('is-ready');
          element.classList.toggle('is-rainy', rainy);
        });

      root
        .querySelectorAll(
          `[data-drawer-rain-note="${CSS.escape(location.handle)}"]`
        )
        .forEach((element) => {
          element.textContent = rainy ? LOCATION_NOTES[location.handle] || '' : '';
          element.classList.toggle('is-ready', rainy && Boolean(element.textContent));
        });
    });

    if (drawerRain) {
      drawerRain.hidden = !rainyMarket;
      drawerRain.style.display = rainyMarket ? '' : 'none';
    }
  };

  renderEvents();

  if (drawerRain) {
    drawerRain.hidden = true;
    drawerRain.style.display = 'none';
  }

  // Weather starts on first drawer open, not every page load.
})();